import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import TextEllipsis from '../../../../../common/textEllipsis'
import { Tooltip } from '../../../../../common/tooltip'
import { valToPercent } from '../../../../../helpers/value'
import { getStatusQuickAssessment } from '../../helper'
import { GROUP_A } from './constant'
import classes from './index.module.scss'

export const TableA = ({ data }) => {
  const renderGroupName = (ratioGroupCode) => {
    const ratio = data.find((item) => item.ratioGroupCode === ratioGroupCode)
    if (!ratio) return <>&nbsp;</>
    return ratio.ratioGroupName
  }

  const renderRatio = (ratioCode) => {
    const ratio = data.find(
      (item) => item.ratioCode.trim() === ratioCode.trim(),
    )
    if (!ratio) return <>&nbsp;</>
    return (
      <>
        <div className={classes.w35}>{ratio.ratioName}</div>
        <div className={classes.w25}>
          <div
            className={[classes.w40, classes.maxWidth40, 'textEnd'].join(' ')}
          >
            {ratio.conditionContent ? (
              <Tooltip tooltipContent={ratio.conditionContent}>
                <TextEllipsis text={valToPercent(ratio.value)} isI18n={false} />
              </Tooltip>
            ) : (
              <TextEllipsis text={valToPercent(ratio.value)} isI18n={false} />
            )}
          </div>
        </div>
        <div className={`${classes.w40} dFlex alignItemsCenter`}>
          {getStatusQuickAssessment(ratio.statusCode, false)}
          <div>{ratio.statusName}</div>
        </div>
      </>
    )
  }

  return (
    <Element className={classes.table} style={{ borderColor: '#D5D5D5' }}>
      <Element
        style={{ borderColor: '#D5D5D5', color: '#191D25' }}
        className={classes.header}
      >
        {[0, 1].map((idx) => (
          <Element
            key={idx}
            className={classes.headerItem}
            style={{ borderColor: '#D5D5D5' }}
          >
            <div className={classes.w35}>
              <Translate value="financialAnalysis.INDICATOR" />
            </div>
            <div className={classes.w25}>
              <div
                className={[classes.w40, classes.maxWidth40, 'textEnd'].join(
                  ' ',
                )}
              >
                {data?.[0]?.year}
              </div>
            </div>
            <div className={classes.w40}>
              <Translate value="financialAnalysis.COMPLIANCE_STATUS" />
            </div>
          </Element>
        ))}
      </Element>

      <Element className={classes.rowWrapper}>
        {GROUP_A.map((row, index) => (
          <Element key={index} className={classes.row}>
            {row.map((item, idx) => (
              <Element
                key={idx}
                className={classes.rowItem}
                style={{
                  borderColor: '#D5D5D5',
                  backgroundColor: item.ratioGroupCode ? '#F9F9F9' : '',
                  fontWeight: item.ratioGroupCode ? '600' : '400',
                }}
              >
                {!!item.ratioGroupCode && renderGroupName(item.ratioGroupCode)}
                {!!item.ratioCode && renderRatio(item.ratioCode)}
              </Element>
            ))}
          </Element>
        ))}
      </Element>
    </Element>
  )
}
